/*
 * The product description, set as prose rather than as a pasted file.
 *
 * The copy is written in a text box with asterisks for bullets, so Shopify
 * stores it as "<p>* Modern Tailored Fit: Designed to offer…</p>" — a run of
 * paragraphs each beginning with a literal asterisk. Rendered as-is it looks
 * like somebody typed it in a notepad and pasted it in, because that is very
 * nearly what happened: twelve of forty suits sampled are written this way and
 * not one of them has a real list in it.
 *
 * Nothing is rewritten at the source. The description is what Shopify sends to
 * Google, to the feeds and to the apps, and reformatting it in the admin would
 * mean doing it again for every product and for every product added after. So
 * the shape is recognised here and rendered properly, and the words are left
 * exactly as they were written.
 *
 * Deliberately conservative. Two consecutive bullets are needed before
 * anything is treated as a list — one line beginning with a dash is a
 * sentence, not a list of one — and any paragraph carrying a script, an
 * iframe or an image is left alone, because the reviews and size-guide apps
 * inject their own markup into this same block.
 */
(function () {
  var root = document.querySelector('.tcfr-desc');
  if (!root) return;

  /* An asterisk, a bullet or a dash, followed by space. The dash needs the
     space: "3-piece" must not look like a bullet. */
  var BULLET = /^\s*[*•·\-–]\s+/;

  /* "Modern Tailored Fit: Designed to…" — a short lead-in before a colon is
     the point of the bullet and reads as one when it is set apart. Capped in
     length so a sentence that merely contains a colon is not carved up. */
  var LEAD = /^([^:]{2,46}):\s*(\S.*)$/;

  function untouchable(el) {
    return !!el.querySelector('script, iframe, link, img, style');
  }

  function bullet(text) {
    var li = document.createElement('li');
    var m = text.match(LEAD);
    if (m) {
      var lead = document.createElement('strong');
      lead.className = 'tcfr-desc__lead';
      lead.textContent = m[1];
      li.appendChild(lead);
      li.appendChild(document.createTextNode(' ' + m[2]));
    } else {
      li.textContent = text;
    }
    return li;
  }

  var run = [];

  function flush() {
    if (run.length < 2) { run = []; return; }
    var list = document.createElement('ul');
    list.className = 'tcfr-desc__list';
    run.forEach(function (p) {
      list.appendChild(bullet(p.textContent.replace(BULLET, '').trim()));
    });
    run[0].parentNode.insertBefore(list, run[0]);
    run.forEach(function (p) { p.remove(); });
    run = [];
  }

  Array.prototype.slice.call(root.children).forEach(function (el) {
    var isBullet = el.tagName === 'P'
      && BULLET.test(el.textContent)
      && !untouchable(el);
    if (isBullet) run.push(el); else flush();
  });
  flush();

  /*
   * "Material : 76% Polyester, 22% Viscose, 2% Spandex" is a specification
   * rather than a sentence, and reads as one once the label is set apart from
   * the value. Only paragraphs that are entirely "label: value" qualify.
   */
  var SPEC = /^([A-Za-z][A-Za-z \-/&]{2,28})\s*:\s*(\S.*)$/;
  Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
    if (untouchable(p)) return;
    var m = p.textContent.trim().match(SPEC);
    if (!m || m[2].length > 120) return;
    p.className = (p.className ? p.className + ' ' : '') + 'tcfr-desc__spec';
    p.textContent = '';
    var label = document.createElement('strong');
    label.textContent = m[1];
    p.appendChild(label);
    p.appendChild(document.createTextNode(' ' + m[2]));
  });

  root.classList.add('tcfr-desc--set');
})();
